// [영화거래소 추천인 코드·정산 2026-07-15]
// 탭1 코드관리: 루트 4개(jb/sub/apple/abc) 아래 하위코드 생성(2~6자 영숫자)·활성토글.
// 탭2 정산통계: 기간별 루트 롤업 카드 → 코드별 표 → 코드 클릭=회원목록 → 회원 클릭=주문상세.
import React, { useState, useEffect, useCallback } from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const fmtWon = (n) => Number(n || 0).toLocaleString('ko-KR');

export default function ReferrerStats() {
  const [tab, setTab] = useState('stats'); // 'stats' | 'codes'

  // ── 코드관리 상태 ──
  const [codes, setCodes] = useState([]);
  const [newCode, setNewCode] = useState('');
  const [newParent, setNewParent] = useState('jb');
  const [newMemo, setNewMemo] = useState('');

  // ── 정산 상태 ──
  const firstOfMonth = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`; };
  const todayStr = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; };
  const [from, setFrom] = useState(firstOfMonth());
  const [to, setTo] = useState(todayStr());
  const [perCode, setPerCode] = useState([]);
  const [perRoot, setPerRoot] = useState([]);
  const [selCode, setSelCode] = useState(null);
  const [members, setMembers] = useState([]);
  const [selMember, setSelMember] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadCodes = useCallback(async () => {
    try {
      const r = await fetch('/request/referral/codes', { credentials: 'include' });
      const d = await r.json();
      if (Array.isArray(d)) setCodes(d);
    } catch (e) { console.error(e); }
  }, []);

  const loadSettlement = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`/request/referral/settlement?from=${from}&to=${to}`, { credentials: 'include' });
      const d = await r.json();
      setPerCode(d.perCode || []);
      setPerRoot(d.perRoot || []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, [from, to]);

  useEffect(() => { loadCodes(); loadSettlement(); /* eslint-disable-next-line */ }, []);

  const createCode = async () => {
    const code = newCode.trim().toLowerCase();
    if (!/^[a-z0-9]{2,6}$/.test(code)) { alert('코드는 2~6자 영문/숫자입니다.'); return; }
    try {
      const r = await fetch('/request/referral/createCode', {
        method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code, parent_code: newParent, memo: newMemo || null })
      });
      const d = await r.json();
      if (r.ok && d.success) { alert(`코드 '${d.code}' 생성 완료`); setNewCode(''); setNewMemo(''); loadCodes(); loadSettlement(); }
      else alert(d.error || '생성 실패');
    } catch (e) { alert('서버 오류: ' + e.message); }
  };

  const toggleCode = async (code, status) => {
    const next = status === 'active' ? 'inactive' : 'active';
    if (!window.confirm(`코드 '${code}'를 ${next === 'active' ? '활성' : '비활성'}으로 바꿀까요?${next === 'inactive' ? '\n(비활성 시 이 코드로 신규 가입 불가, 기존 회원·정산은 유지)' : ''}`)) return;
    try {
      const r = await fetch('/request/referral/setCodeStatus', {
        method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code, status: next })
      });
      const d = await r.json();
      if (r.ok && d.success) loadCodes();
      else alert(d.error || '변경 실패');
    } catch (e) { alert('서버 오류: ' + e.message); }
  };

  const openMembers = async (code) => {
    setSelCode(code); setSelMember(null); setOrders([]);
    try {
      const r = await fetch(`/request/referral/members?code=${encodeURIComponent(code)}`, { credentials: 'include' });
      setMembers(await r.json());
    } catch (e) { console.error(e); }
  };

  const openOrders = async (m) => {
    setSelMember(m);
    try {
      const r = await fetch(`/request/referral/orders?user=${encodeURIComponent(m.phone_number)}`, { credentials: 'include' });
      setOrders(await r.json());
    } catch (e) { console.error(e); }
  };

  const exportExcel = async () => {
    const wb = new ExcelJS.Workbook();
    const ws1 = wb.addWorksheet('루트별 합산');
    ws1.addRow(['부모코드', '가입자수', '주문건수', '매출합', '관람인원합', '취소진행중']);
    perRoot.forEach((r) => ws1.addRow([r.root, r.member_cnt, r.order_cnt, Number(r.sales_sum), r.viewer_sum, Number(r.limbo_sum)]));
    const ws2 = wb.addWorksheet('코드별 상세');
    ws2.addRow(['코드', '부모코드', '상태', '가입자수', '주문건수', '매출합', '관람인원합', '취소진행중']);
    perCode.forEach((r) => ws2.addRow([r.code, r.parent_code || '', r.status, r.member_cnt, r.order_cnt, Number(r.sales_sum), r.viewer_sum, Number(r.limbo_sum)]));
    const buf = await wb.xlsx.writeBuffer();
    saveAs(new Blob([buf]), `추천인정산_${from}_${to}.xlsx`);
  };

  const roots = codes.filter((c) => !c.parent_code);

  return (
    <div style={S.page}>
      <h2 style={{ margin: '0 0 12px' }}>추천인코드 · 정산</h2>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <button type="button" style={tab === 'stats' ? S.tabOn : S.tabOff} onClick={() => setTab('stats')}>정산통계</button>
        <button type="button" style={tab === 'codes' ? S.tabOn : S.tabOff} onClick={() => setTab('codes')}>코드관리</button>
      </div>

      {tab === 'codes' && (
        <div>
          <div style={S.box}>
            <b>하위 코드 추가</b>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 8, flexWrap: 'wrap' }}>
              <label>부모(루트)&nbsp;
                <select value={newParent} onChange={(e) => setNewParent(e.target.value)} style={S.input}>
                  {roots.map((r) => <option key={r.code} value={r.code}>{r.code}</option>)}
                </select>
              </label>
              <input style={S.input} placeholder="새 코드 (2~6자 영문/숫자)" value={newCode} maxLength={6}
                onChange={(e) => setNewCode(e.target.value.replace(/[^a-zA-Z0-9]/g, '').toLowerCase())} />
              <input style={{ ...S.input, width: 200 }} placeholder="메모(선택)" value={newMemo} onChange={(e) => setNewMemo(e.target.value)} />
              <button type="button" style={S.primary} onClick={createCode}>추가</button>
            </div>
            <div style={{ fontSize: 12, color: '#666', marginTop: 6 }}>코드는 삭제할 수 없고 비활성 처리만 가능합니다(비활성=신규 가입 차단, 기존 정산 유지).</div>
          </div>

          {roots.map((root) => (
            <div key={root.code} style={S.box}>
              <b style={{ fontSize: 15 }}>{root.code}</b> <span style={S.badgeRoot}>루트</span>
              <table style={S.table}>
                <thead><tr>{['코드', '상태', '가입자수', '메모', '생성일', '생성자', ''].map((h) => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
                <tbody>
                  {codes.filter((c) => c.parent_code === root.code).map((c) => (
                    <tr key={c.code}>
                      <td style={S.td}><b>{c.code}</b></td>
                      <td style={S.td}>{c.status === 'active' ? <span style={{ color: '#16a34a' }}>활성</span> : <span style={{ color: '#e53e3e' }}>비활성</span>}</td>
                      <td style={S.td}>{c.member_cnt}</td>
                      <td style={S.td}>{c.memo || '-'}</td>
                      <td style={S.td}>{c.created_at}</td>
                      <td style={S.td}>{c.created_by || '-'}</td>
                      <td style={S.td}><button type="button" style={S.small} onClick={() => toggleCode(c.code, c.status)}>{c.status === 'active' ? '비활성화' : '활성화'}</button></td>
                    </tr>
                  ))}
                  {codes.filter((c) => c.parent_code === root.code).length === 0 && (
                    <tr><td style={{ ...S.td, color: '#999' }} colSpan={7}>하위 코드 없음</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      )}

      {tab === 'stats' && (
        <div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 12, flexWrap: 'wrap' }}>
            <label>기간&nbsp;<input type="date" value={from} onChange={(e) => setFrom(e.target.value)} style={S.input} /></label>
            ~ <input type="date" value={to} onChange={(e) => setTo(e.target.value)} style={S.input} />
            <button type="button" style={S.primary} onClick={loadSettlement} disabled={loading}>{loading ? '조회 중…' : '조회'}</button>
            <button type="button" style={S.small} onClick={exportExcel}>엑셀 내보내기</button>
            <span style={{ fontSize: 12, color: '#666' }}>매출합=결제성공(부분취소는 차감 후) / 취소진행중은 별도</span>
          </div>

          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 14 }}>
            {perRoot.map((r) => (
              <div key={r.root} style={S.card}>
                <div style={{ fontWeight: 700, fontSize: 15 }}>{r.root}</div>
                <div style={{ fontSize: 13, marginTop: 6, lineHeight: 1.7 }}>
                  가입 <b>{r.member_cnt}</b>명 · 주문 <b>{r.order_cnt}</b>건<br />
                  매출 <b>{fmtWon(r.sales_sum)}</b>원 · 관람 <b>{r.viewer_sum}</b>명
                  {Number(r.limbo_sum) > 0 && <><br /><span style={{ color: '#d69e2e' }}>취소진행중 {fmtWon(r.limbo_sum)}원</span></>}
                </div>
              </div>
            ))}
          </div>

          <table style={S.table}>
            <thead><tr>{['코드', '부모', '상태', '가입자수', '주문건수', '매출합(원)', '관람인원', '취소진행중(원)'].map((h) => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
            <tbody>
              {perCode.map((r) => (
                <tr key={r.code} onClick={() => openMembers(r.code)}
                    style={{ cursor: 'pointer', background: selCode === r.code ? '#ebf8ff' : undefined }}>
                  <td style={S.td}><b>{r.code}</b></td>
                  <td style={S.td}>{r.parent_code || (r.code === '(코드없음)' ? '-' : '루트')}</td>
                  <td style={S.td}>{r.status}</td>
                  <td style={S.td}>{r.member_cnt}</td>
                  <td style={S.td}>{r.order_cnt}</td>
                  <td style={{ ...S.td, textAlign: 'right' }}>{fmtWon(r.sales_sum)}</td>
                  <td style={S.td}>{r.viewer_sum}</td>
                  <td style={{ ...S.td, textAlign: 'right', color: Number(r.limbo_sum) > 0 ? '#d69e2e' : undefined }}>{fmtWon(r.limbo_sum)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ fontSize: 12, color: '#666', margin: '6px 0 14px' }}>행을 클릭하면 해당 코드의 회원 목록이 아래에 표시됩니다.</div>

          {selCode && (
            <div style={S.box}>
              <b>[{selCode}] 회원 목록</b> ({members.length}명)
              <table style={S.table}>
                <thead><tr>{['이름', '계정', '실전화', '가입일', '최근접속', '주문건수', '매출합(원)', '관람인원'].map((h) => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
                <tbody>
                  {members.map((m) => (
                    <tr key={m.id} onClick={() => openOrders(m)}
                        style={{ cursor: 'pointer', background: selMember && selMember.id === m.id ? '#ebf8ff' : undefined }}>
                      <td style={S.td}>{m.name}</td>
                      <td style={S.td}>{m.phone_number}</td>
                      <td style={S.td}>{m.contact_phone || '-'}</td>
                      <td style={S.td}>{m.joined_at}</td>
                      <td style={S.td}>{m.last_login_at || '-'}</td>
                      <td style={S.td}>{m.order_cnt}</td>
                      <td style={{ ...S.td, textAlign: 'right' }}>{fmtWon(m.sales_sum)}</td>
                      <td style={S.td}>{m.viewer_sum}</td>
                    </tr>
                  ))}
                  {members.length === 0 && <tr><td style={{ ...S.td, color: '#999' }} colSpan={8}>회원 없음</td></tr>}
                </tbody>
              </table>
              <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>회원을 클릭하면 주문 상세가 아래에 표시됩니다.</div>
            </div>
          )}

          {selMember && (
            <div style={S.box}>
              <b>{selMember.name} 주문 상세</b> ({orders.length}건)
              <table style={S.table}>
                <thead><tr>{['주문일시', '영화', '극장', '관람일', '시간', '인원', '결제금액(원)', '취소금액(원)', '상태', '결제수단'].map((h) => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
                <tbody>
                  {orders.map((o) => (
                    <tr key={o.id}>
                      <td style={S.td}>{o.ordered_at}</td>
                      <td style={{ ...S.td, whiteSpace: 'normal' }}>{o.movie_title}</td>
                      <td style={S.td}>{o.theater}</td>
                      <td style={S.td}>{o.screening_date || o.show_date || '-'}</td>
                      <td style={S.td}>{o.screening_time || '-'}</td>
                      <td style={S.td}>{o.viewers}</td>
                      <td style={{ ...S.td, textAlign: 'right' }}>{fmtWon(o.payamount)}</td>
                      <td style={{ ...S.td, textAlign: 'right' }}>{fmtWon(o.cancelled_amount)}</td>
                      <td style={S.td}>{o.payment_status}</td>
                      <td style={S.td}>{o.payment_method}</td>
                    </tr>
                  ))}
                  {orders.length === 0 && <tr><td style={{ ...S.td, color: '#999' }} colSpan={10}>주문 없음</td></tr>}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

const S = {
  page: { padding: 20, width: '100%', overflowY: 'auto', textAlign: 'left' },
  tabOn: { padding: '8px 18px', border: 'none', borderRadius: 6, background: '#2b6cb0', color: '#fff', fontWeight: 700, cursor: 'pointer' },
  tabOff: { padding: '8px 18px', border: '1px solid #cbd5e0', borderRadius: 6, background: '#fff', color: '#333', cursor: 'pointer' },
  box: { border: '1px solid #e2e8f0', borderRadius: 8, padding: 14, margin: '10px 0', background: '#fff' },
  card: { border: '1px solid #e2e8f0', borderRadius: 8, padding: 12, minWidth: 190, background: '#f8fafc' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13, marginTop: 8 },
  th: { border: '1px solid #e2e8f0', background: '#f1f5f9', padding: '6px 8px', whiteSpace: 'nowrap' },
  td: { border: '1px solid #eee', padding: '5px 8px', whiteSpace: 'nowrap', textAlign: 'center' },
  input: { padding: '6px 8px', border: '1px solid #ccc', borderRadius: 4, fontSize: 13 },
  primary: { padding: '6px 14px', border: 'none', borderRadius: 4, background: '#2b6cb0', color: '#fff', cursor: 'pointer', fontWeight: 600 },
  small: { padding: '4px 10px', border: '1px solid #cbd5e0', borderRadius: 4, background: '#fff', cursor: 'pointer', fontSize: 12 },
  badgeRoot: { fontSize: 11, background: '#2b6cb0', color: '#fff', borderRadius: 4, padding: '2px 6px', marginLeft: 6 },
};
